import { Outlet } from 'react-router';

const STPDemoLayout = () => {
  return (
    <div className='min-h-screen bg-neutralColor-lightest'>
      <div className='max-w-7xl mx-auto py-6 sm:px-6 lg:px-8'>
        <div className='px-4 py-6 sm:px-0'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default STPDemoLayout;
